<template>
  <div class="app-container">
    <el-row :gutter="20">
      <el-col :span="24">
        <el-form :model="queryParams" ref="queryParams" size="small" label-width="100px">
          <!-- 第一行搜索条件 -->
          <el-row :gutter="20">
            <el-col :span="4">
              <el-form-item label="状态">
                <el-select v-model="queryParams.jgUpdState" placeholder="请选择状态" style="width: 100%" @change="handleSearch">
                  <el-option label="已确认" value="0" />
                  <el-option label="未确认" value="1" />
                  <el-option label="全部" value="-1" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="客户名称">
                <el-input v-model="queryParams.compNames" placeholder="请输入客户名称" @keyup.enter.native="handleSearch" />
                <CustomerDetails v-model="queryParams.compNames" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="使用单位">
                <el-input v-model="queryParams.usingUnit" placeholder="请输入使用单位" clearable @keyup.enter.native="handleSearch" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="小区名称">
                <el-input v-model="queryParams.houseName" placeholder="请输入小区名称" clearable @keyup.enter.native="handleSearch" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="电梯识别码">
                <el-input v-model="queryParams.OIDNO" placeholder="请输入电梯识别码" clearable @keyup.enter.native="handleSearch" />
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 第二行搜索条件 -->
          <el-row :gutter="20">
            <el-col :span="4">
              <el-form-item label="到检月份">
                <!-- <el-date-picker v-model="queryParams.inspectionMonthList" type="month" placeholder="请选择到检月份" clearable value-format="yyyy-MM" style="width: 100%" @change="handleSearch" />
                 -->
                <el-date-picker v-model="queryParams.inspectionMonthList" type="months" value-format="yyyy-MM" placeholder="请选择到检月份" clearable style="width: 100%;" @change="handleSearch" />
              
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="认领日期">
                <el-date-picker v-model="queryParams.claimDate" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width: 100%" @change="handleSearch" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="确认日期">
                <el-date-picker v-model="queryParams.confirmDate" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width: 100%" @change="handleSearch" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="使用区域">
                <ChinaAreaCascader :multiple="true" :checkStrictly="true" width="100%" v-model="areaSelectedValue" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="待状态备注">
                <el-input v-model="queryParams.pendingConfirmRemark" placeholder="请输入待状态备注" clearable @keyup.enter.native="handleSearch" />
              </el-form-item>
            </el-col>
          </el-row>
          <div style="text-align: center;margin-bottom: 10px;">
            <PermissionMethodToolbar :url="url" :id="'toolbar'" @handleSearch="handleSearch" @handleAdd="handleAdd" @exportToExcel="exportToExcel" @handleUpload="handleUpload"
                                     @handleSupervision="handleSupervision" @handlePendingConfirmRemark="handlePendingConfirmRemark" />
          </div>
          <el-dialog title="待确认备注" :visible.sync="pendingConfirmRemarkDialogVisible" width="500px" :before-close="closePendingConfirmRemarkDialog">
            <el-form :model="pendingConfirmRemarkForm" ref="pendingConfirmRemarkForm" size="small" label-width="100px" :rules="pendingConfirmRemarkRules">
              <el-form-item label="待确认备注" prop="pendingConfirmRemark">
                <el-input v-model="pendingConfirmRemarkForm.pendingConfirmRemark" type="textarea" :rows="3" placeholder="请输入待确认备注" maxlength="200" show-word-limit />
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="closePendingConfirmRemarkDialog">取 消</el-button>
              <el-button type="primary" :loading="pendingConfirmRemarkSubmitting" @click="submitPendingConfirmRemark">确 定</el-button>
            </span>
          </el-dialog>
          <!-- 添加遮罩层和加载状态的表格 -->
          <el-table :data="tableData" border style="width: 100%; margin-top: 20px" v-loading="loading" element-loading-text="正在查询数据..." element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)" @selection-change="handleSelectionChange" height="520" :cell-style="setCellStyle">
            <el-table-column type="selection" width="55" fixed="left"></el-table-column>
            <el-table-column type="index" width="55" fixed="left"></el-table-column>
            <el-table-column label="状态" prop="jgUpdState" fixed="left" >
              <template slot-scope="scope">
                <span :class="['status-text', `status-${scope.row.jgUpdState}`]">
                  {{ getStatusText(scope.row.jgUpdState) }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="待确认备注" prop="pendingConfirmRemark" show-overflow-tooltip width="120" fixed="left"/>
            <el-table-column label="登记日期" prop="registrationDate" show-overflow-tooltip fixed="left" width="120" />
            <el-table-column label="识别码" prop="OIDNO" show-overflow-tooltip fixed="left" width="120" />
            <el-table-column label="客户名称" prop="compName" show-overflow-tooltip fixed="left" width="200"/>
            
            <el-table-column label="现场联系人及电话" prop="siteContactAndTel" show-overflow-tooltip width="160" />
            <el-table-column label="使用单位名称" prop="usingUnit" show-overflow-tooltip width="160" />
            <el-table-column label="监管使用单位" prop="USE_UNT_NAME" show-overflow-tooltip width="160" />
            <el-table-column label="小区名称" prop="houseName" show-overflow-tooltip />
            <el-table-column label="区域" prop="EQP_AREA_NAME" show-overflow-tooltip width="260" />
            <el-table-column label="到检年月" prop="inspectionMonth" show-overflow-tooltip />
            <el-table-column label="社会信用代码" prop="unifiedCreditCode" show-overflow-tooltip width="160" />
            <el-table-column label="单位使用地址" prop="USE_UNT_ADDR" show-overflow-tooltip width="160" />
            <el-table-column label="业务联系人及电话" prop="businessContactAndTel" show-overflow-tooltip width="160"/>
            <el-table-column label="认领日期" prop="claimDate" show-overflow-tooltip width="120" />
            <el-table-column label="检测费用" prop="finalPrice" show-overflow-tooltip />
            <el-table-column label="确认日期" prop="confirmDate" show-overflow-tooltip width="120" >
              <template slot-scope="scope">
                <span>{{ scope.row.confirmDate ? scope.row.confirmDate : '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="备注" prop="remark" show-overflow-tooltip />
           
            <el-table-column label="委托单编号" prop="entrustNum" show-overflow-tooltip width="180" />
            <el-table-column label="操作" width="320">
              <template slot-scope="scope">
                <PermissionMethodRow :url="url" :id="'rowtoolbar'" :disabledButtons="getDisabledButtons(scope.row)" @handleEdit="handleEdit(scope.row)" @handleDelete="handleDelete(scope.row)"
                                     @DeviceDetails="DeviceDetails(scope.row)" @PreviewMemoPDF="PreviewMemoPDF(scope.row)" />
              </template>
            </el-table-column>
          </el-table>
          <el-pagination v-show="total > 0" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryParams.currPage" :page-sizes="[10, 20, 50, 100,200,500,1000 ]"
                         :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" style="margin-top: 20px; text-align: right;">
          </el-pagination>
        </el-form>
      </el-col>
    </el-row>

    <!-- 隐藏的文件输入元素 -->
    <input ref="fileInput" type="file" accept=".xlsx,.xls,.csv" style="display: none" @change="handleFileChange" />

    <!-- 新增/修改弹出层 -->
    <AddAndEdit ref="addAndEdit" @refresh="handleQuery" />

    <!-- 设备详情弹出层 -->
    <EquipmentConfirmDialog ref="equipmentConfirmDialog" />

    <!-- 监管确认列表弹出层 -->
    <el-dialog title="监管确认列表" :visible.sync="confirmDialogVisible" width="80%" :before-close="closeConfirmDialog">
      <el-table :data="confirmListData" border style="width: 100%">
        <el-table-column prop="OIDNO" label="电梯识别码" show-overflow-tooltip />
        <el-table-column prop="ELEFLOORNUMBER" label="层数" />
        <el-table-column prop="inspectionMonth" label="年检月份" />
        <el-table-column prop="usingUnit" label="使用单位" show-overflow-tooltip />
        <el-table-column prop="testcharge" label="单价" />
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeConfirmDialog">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- 文件预览对话框 -->
    <el-dialog :title="previewTitle" :visible.sync="previewDialogVisible" width="80%" append-to-body :before-close="closePreviewDialog">
      <PdfImgViewer ref="pdfImgViewer" :fileName="currentFileUUID" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="closePreviewDialog">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { queryCustInfoList, importCustInfo, exportCustInfo, updateCustInfoState, supervisionDownload, supervisionConfirmList, batchPendingConfirmRemark } from '@/api/contract/contract'
import AddAndEdit from './AddAndEdit.vue'
import EquipmentConfirmDialog from '../OriginalManagement/EquipmentConfirmDialog.vue'
import PdfImgViewer from '@/components/pdfview/PdfImgViewer.vue'
import ChinaAreaCascader from '@/components/ChinaAreaCascader/index.vue'

export default {
  components: {
    AddAndEdit,
    EquipmentConfirmDialog,
    PdfImgViewer,
    ChinaAreaCascader
  },
  props: {
    url: {
      type: String
    }
  },
  data () {
    return {
      queryParams: {
        registrationDate: [],
        currPage: 1,
        pageSize: 1000,
        usingUnit: '',
        inspectionMonthList: [],
        elevatorCode: '',
        jgUpdState: '1',
        houseName: '',
        claimDate: [],
        confirmDate: [],
        EQP_AREA_NAME: '',
        claimStatus: '0',  // 默认只显示已认领的数据
        pendingConfirmRemark: '',
      },
      areaSelectedValue: [], // ChinaAreaCascader 多选值
      tableData: [], // 这里将填充从API获取的数据
      total: 0,
      loading: false,
      uploadLoading: false, // 上传加载状态
      selectedRows: [], // 选中的行数据
      confirmDialogVisible: false, // 确认列表弹窗显示状态
      confirmListData: [], // 确认列表数据
      eventSource: null, // SSE连接对象
      // 文件预览对话框
      previewDialogVisible: false,
      currentFileUUID: '',
      previewTitle: '',
      // 待确认备注
      pendingConfirmRemarkDialogVisible: false,
      pendingConfirmRemarkSubmitting: false,
      pendingConfirmRemarkForm: {
        pendingConfirmRemark: ''
      },
      pendingConfirmRemarkRules: {
        pendingConfirmRemark: [
          { required: true, message: '请输入待确认备注', trigger: 'blur' }
        ]
      }
    };
  },
  created () {
    //this.handleQuery()
  },
  watch: {
    areaSelectedValue (newVal) {
      this.handleAreaChange(newVal)
    }
  },
  methods: {
    // 处理区域选择变化
    handleAreaChange (value) {
      // ChinaAreaCascader 多选时返回字符串数组，例如 ['福建省/福州市/仓山区/上街镇']
      if (!Array.isArray(value) || value.length === 0) {
        this.queryParams.EQP_AREA_NAME = ''
        return
      }
      this.queryParams.EQP_AREA_NAME = value.join(',')
    },
    handleSearch () {
      this.queryParams.currPage = 1
      this.handleQuery()
    },
    handleQuery () {
      // 开始查询时显示加载状态
      this.loading = true
      queryCustInfoList(this.queryParams).then(res => {
        this.tableData = res.additionalData.records
        this.total = res.additionalData.total
        this.queryParams.currPage = res.additionalData.current
        this.queryParams.pageSize = res.additionalData.size
        this.loading = false // 查询完成后隐藏加载状态
      }).catch(err => {
        this.$message.error(err.message)
        this.loading = false // 查询失败时也要隐藏加载状态
      })
    },
    handleAdd () {
      // 新增逻辑
      this.$refs.addAndEdit.showAdd()
    },
    exportToExcel () {
      // 导出逻辑
      this.$message.success('正在导出客户检测信息...')

      // 调用导出接口
      exportCustInfo(this.queryParams).then(response => {
        // 创建下载链接
        const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);

        // 创建下载链接元素
        const link = document.createElement('a');
        link.href = url;
        link.download = '客户检测信息.xlsx'; // 文件名

        // 触发下载
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();

        // 清理
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.$message.success('导出成功')
      }).catch(error => {
        console.error('导出失败:', error)
        this.$message.error('导出失败：' + (error.message || '未知错误'))
      })
    },
    handlePendingConfirmRemark () {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请先选择要添加待确认备注的数据')
        return
      }
      // 仅未确认（jgUpdState=1）可添加备注，已确认不需要备注
      const confirmedRows = this.selectedRows.filter(row => row.jgUpdState == '0' || row.jgUpdState === 0)
      if (confirmedRows.length > 0) {
        const oidnoList = confirmedRows.map(item => item.OIDNO).join('、')
        this.$message.warning(`选中数据中识别码 "${oidnoList}" 已确认，无需添加待确认备注`)
        return
      }
      const invalidRows = this.selectedRows.filter(row => row.jgUpdState != '1' && row.jgUpdState !== 1)
      if (invalidRows.length > 0) {
        const oidnoList = invalidRows.map(item => item.OIDNO).join('、')
        this.$message.warning(`选中数据中识别码 "${oidnoList}" 不是未确认状态，无法添加待确认备注`)
        return
      }
      const missingEntrNum = this.selectedRows.filter(item => !item.entrustNum)
      if (missingEntrNum.length > 0) {
        const oidnoList = missingEntrNum.map(item => item.OIDNO).join('、')
        this.$message.warning(`选中数据中识别码 "${oidnoList}" 缺少委托单编号，无法添加备注`)
        return
      }
      this.pendingConfirmRemarkForm.pendingConfirmRemark = ''
      this.pendingConfirmRemarkDialogVisible = true
      this.$nextTick(() => {
        this.$refs.pendingConfirmRemarkForm && this.$refs.pendingConfirmRemarkForm.clearValidate()
      })
    },
    closePendingConfirmRemarkDialog () {
      this.pendingConfirmRemarkDialogVisible = false
      this.pendingConfirmRemarkForm.pendingConfirmRemark = ''
      this.pendingConfirmRemarkSubmitting = false
      this.$nextTick(() => {
        this.$refs.pendingConfirmRemarkForm && this.$refs.pendingConfirmRemarkForm.clearValidate()
      })
    },
    submitPendingConfirmRemark () {
      this.$refs.pendingConfirmRemarkForm.validate(valid => {
        if (!valid) return
        const entrNums = this.selectedRows.map(item => item.entrustNum)
        this.pendingConfirmRemarkSubmitting = true
        batchPendingConfirmRemark({
          entrNums,
          pendingConfirmRemark: this.pendingConfirmRemarkForm.pendingConfirmRemark
        }).then(res => {
          if (res && res.retCode === 'ok') {
            this.$message.success(res.retMsg || '待确认备注保存成功')
            this.closePendingConfirmRemarkDialog()
            this.handleQuery()
          } else {
            this.$message.error(res.retMsg || '待确认备注保存失败')
          }
        }).catch(err => {
          this.$message.error(err.message || '待确认备注保存失败')
        }).finally(() => {
          this.pendingConfirmRemarkSubmitting = false
        })
      })
    },
    handleUpload () {
      // 触发文件选择器
      this.$refs.fileInput.click()
    },
    handleFileChange (event) {
      const file = event.target.files[0]
      if (!file) {
        return
      }

      // 文件类型验证
      const allowedTypes = [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
        'application/vnd.ms-excel', // .xls
        'text/csv' // .csv
      ]

      if (!allowedTypes.includes(file.type)) {
        this.$message.error('请选择正确的文件格式（支持 .xlsx, .xls, .csv）')
        this.resetFileInput()
        return
      }

      // 文件大小验证（限制为10MB）
      const maxSize = 10 * 1024 * 1024 // 10MB
      if (file.size > maxSize) {
        this.$message.error('文件大小不能超过10MB')
        this.resetFileInput()
        return
      }

      // 确认上传
      this.$confirm(`确定要上传文件 "${file.name}" 吗？`, '确认上传', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.uploadFile(file)
      }).catch(() => {
        this.resetFileInput()
      })
    },
    uploadFile (file) {
      // 创建FormData对象
      const formData = new FormData()
      formData.append('file', file)

      // 开始上传，显示全局加载提示
      const loading = this.$loading({
        lock: true,
        text: '正在上传文件，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      // 调用上传接口
      importCustInfo(formData).then(res => {
        loading.close()
        this.$message.success('文件上传成功！')

        // 上传成功后重新查询数据
        this.handleQuery()

        // 重置文件输入
        this.resetFileInput()
      }).catch(err => {
        loading.close()
        this.$message.error(err.message || '文件上传失败，请重试')
        this.resetFileInput()
      })
    },
    resetFileInput () {
      // 重置文件输入元素
      this.$refs.fileInput.value = ''
    },
    handleEdit (row) {
      // 修改逻辑
      this.$refs.addAndEdit.showEdit(row)
    },
    handleDelete (row) {
      // 删除逻辑
      this.$confirm(`确定要修改该客户检测信息状态吗为${row.jgUpdState === '1' ? '已确认' : row.jgUpdState === '0' ? '未确认' : ''}？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        updateCustInfoState(row.jgUpdState === '1' ? '0' : '1', row.custPid).then(res => {
          if (res && res.retCode === 'ok') {
            this.$message.success('修改成功')
          } else {
            this.$message.error('修改失败')
          }
          this.handleQuery()
        })
      })
    },
    DeviceDetails (row) {
      // 检查是否有OIDNO
      if (!row.entrustNum) {
        this.$message.warning('该记录没有委托单编号，无法查看设备详情')
        return
      }
      // 打开设备详情弹窗
      this.$refs.equipmentConfirmDialog && this.$refs.equipmentConfirmDialog.show(row, 'view')
    },
    handleSupervision () {
      // 监管下载逻辑
      if (this.selectedRows.length === 0) {
        this.$message.warning('请先选择要监管下载的数据')
        return
      }

      // 检查是否有已确认的数据（jgUpdState为'0'）
      const hasConfirmedData = this.selectedRows.some(row => row.jgUpdState == '0');
      if (hasConfirmedData) {
        this.$message.warning('选中的数据中有已确认的数据，不允许再次下载');
        return;
      }

      this.$confirm('确定要对选中的数据进行监管下载吗？', '确认监管下载', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 筛选出选中数据中jgUpdState为1或2的行
        const validSelectedRows = this.selectedRows.filter(row =>
          row.jgUpdState === '1' || row.jgUpdState === '2'
        );

        // 如果没有符合条件的选中行，直接返回
        if (validSelectedRows.length === 0) {
          this.$message.warning('请选择未确认状态数据进行操作');
          return;
        }
        this.performSupervisionDownload(validSelectedRows)
      })
    },
    // 执行监管下载
    performSupervisionDownload (validSelectedRows) {
      // 提取符合条件的行的entrustNum集合
      const selectedEntrustNums = new Set(validSelectedRows.map(row => row.entrustNum));
      // 调用监管下载接口，只传递符合条件的行
      supervisionDownload(validSelectedRows).then(res => {
        if (res && res.retCode === 'ok') {
          // 下载成功，调用确认列表接口
          // this.getConfirmationList(loading)
          const taskId = res.additionalData;

          // 只将符合条件的选中行的jgUpdState设置为'-1'
          this.tableData.forEach(item => {
            if (selectedEntrustNums.has(item.entrustNum)) {
              item.jgUpdState = '-1';
            }
          })
          this.createSSEConnection(taskId);
        } else {
          this.$message.error(res.retMsg || '监管下载失败')
        }
      }).catch(err => {
        this.$message.error(err.retMsg || '监管下载失败，请重试')
      })
    },
    // 获取确认列表
    getConfirmationList (loading) {
      const OIDNOS = this.selectedRows.map(row => row.OIDNO)
      const params = {
        currPage: 1,
        OIDNOS: OIDNOS
      }

      supervisionConfirmList(params).then(res => {
        loading.close()
        if (res && res.retCode === 'ok') {
          this.confirmListData = res.additionalData.records || res.data || []
          this.confirmDialogVisible = true
          this.$message.success('监管下载成功')
        } else {
          this.$message.error(res.message || '获取确认列表失败')
        }
      }).catch(err => {
        loading.close()
        this.$message.error(err.message || '获取确认列表失败，请重试')
      })
    },
    // 处理表格选择变化
    handleSelectionChange (selection) {
      this.selectedRows = selection
    },
    handleSizeChange (val) {
      this.queryParams.pageSize = val
      this.queryParams.currPage = 1
      this.handleQuery()
    },
    handleCurrentChange (val) {
      this.queryParams.currPage = val
      this.handleQuery()
    },
    // 关闭确认列表弹窗
    closeConfirmDialog () {
      this.confirmDialogVisible = false
      this.confirmListData = []
    },
    // 创建SSE连接
    createSSEConnection (taskId) {
      const loading = this.$loading({
        lock: true,
        text: '正在进行监管下载...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      // 关闭已有连接（避免重复连接）
      if (this.eventSource) {
        this.eventSource.close();
      }
      // 获取token
      const token = localStorage.getItem('authorization') || '';
      // 建立SSE连接（GET请求），将token作为URL参数传递
      this.eventSource = new EventSource(`/api/regeqpquery/sse/process?taskId=${taskId}&authorization=${token}`);
      // 监听SSE消息（接收后端推送的结果）
      this.eventSource.onmessage = (event) => {
        console.log('onmessage event....');
        console.log('onmessage event', event);
        const data = JSON.parse(event.data);
        console.log('onmessage', data);
        if (data.status === 'finish') {
          // 所有ID处理完成
          // alert(data.msg);
          loading.close();
          this.$message.success(data.msg || '所有数据处理完成');
          this.eventSource.close(); // 关闭SSE连接
        } else if (data.status === 'error') {
          loading.close();
          this.$message.error(data.msg || '处理错误，请重试');
          this.eventSource.close();
        } else {
          // 更新对应ID的状态
          this.tableData.forEach(item => {
            if (item.entrustNum === data.entrustNum) {
              console.log(data);
              item.jgUpdState = data.status;
              //item.EQP_AREA_NAME = data.EQP_AREA_NAME || null;
              if (data.status === '0') {
                item.finalPrice = data.finalPrice || null;
              } else {
                item.remark = data.msg
              }
              this.handleQuery()
              // console.log('更新状态', item);
            }
          });
        }
      };

      // 监听SSE错误
      this.eventSource.onerror = (error) => {
        loading.close();
        console.error('SSE连接错误：', error);
        this.eventSource.close();
      };

      // 监听SSE连接关闭
      this.eventSource.onclose = () => {
        loading.close();
        console.log('SSE连接已关闭');
      };
    },
    // 获取状态颜色
    getStatusColor (status) {
      switch (status) {
        case '-1':
          return 'orange';
        case '0':
          return 'green';
        case '1':
          return 'black';
        case '2':
          return 'red';
        default:
          return 'gray';
      }
    },
    // 获取状态文本
    getStatusText (status) {
      switch (status) {
        case '-1':
          return '确认中...';
        case '0':
          return '已确认';
        case '1':
          return '未确认';
        case '2':
          return '确认失败';
        default:
          return status;
      }
    },
    /**
* 获取禁用的按钮列表
* @param {Object} row - 当前行数据
* @returns {Array} 禁用的按钮名称数组
*/
    getDisabledButtons (row) {
      if (row.jgUpdState == '0') {
        return ['handleEdit']
      }
      if (row.jgUpdState != '0') {
        return ['DeviceDetails']
      }

      return []
    },
    // 预览文件
    PreviewMemoPDF (row) {
      if (!row.memoFileUUID) {
        this.$message.warning('文件不存在');
        return;
      }
      this.currentFileUUID = row.memoFileUUID;
      this.previewTitle = '备忘录文件';
      this.previewDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.pdfImgViewer) {
          this.$refs.pdfImgViewer.init();
        }
      });
    },
    // 关闭文件预览对话框
    closePreviewDialog () {
      this.previewDialogVisible = false;
      this.currentFileUUID = '';
      this.previewTitle = '';
    },
    // 表格单元格样式设置
    setCellStyle ({ row, column }) {
      // 只判断监管下载完成的（已确认状态）
      if (row.jgUpdState !== '0') {
        return {};
      }

      // 判断使用单位是否一致
      const usingUnit = row.usingUnit || '';
      const USE_UNT_NAME = row.USE_UNT_NAME || '';

      // 如果两个字段都为空，认为是一致的
      if (!usingUnit && !USE_UNT_NAME) {
        return {};
      }

      // 如果不一致，整行标红
      if (usingUnit.trim() !== USE_UNT_NAME.trim()) {
        return { color: 'red' };
      }

      // 一致则使用默认样式
      return {};
    }
  },
  beforeDestroy () {
    // 组件销毁时关闭SSE连接
    if (this.eventSource) {
      this.eventSource.close();
    }
  }
};
</script>

<style scoped>
/* 状态文本颜色样式 */
.status-text {
  font-weight: 500;
}

.status--1 {
  color: orange;
}

.status-0 {
  color: green;
}

.status-1 {
  color: black;
}

.status-2 {
  color: red;
}
::v-deep .el-table__body-wrapper {
  z-index: 2;
}
</style>